baguetteBox.run(".lightbox", {
    fullScreen: true,
    titleTag: true,
    async: true
});

if(document.getElementsByClassName("ce-uploads-imagegallery")) {
    baguetteBox.run(".ce-uploads-imagegallery", {
        fullScreen: true,
        titleTag: true,
        async: true
    });
}
